import useRead from "./useRead";
import useCreate from "./useCreate";
import toast from "react-hot-toast";

const useOrderSettings = ({ onSuccess, onSaveSuccess } = {}) => {
  const {
    data: orderSettingsData,
    paramsObject,
    setGetListParams,
  } = useRead({
    url: "fetch_order_settings",
    initialData: {},
    method: "GET",
    enabled: true,
    onSuccess,
  });

  const { setDataToServer } = useCreate({
    url: "manage_order_settings",
    // No refreshUrl!
    onSuccess: (res, reqParams) => {
      toast.success("Order settings saved successfully!", {
        position: "top-right",
        duration: 3000,
      });
      // Pass new ids to the component if present
      if (onSaveSuccess && res?.order_settings_id && res?.company_settings_id) {
        onSaveSuccess({
          order_settings_id: res.order_settings_id,
          company_settings_id: res.company_settings_id,
          settings_type: reqParams.settings_type,
        });
      }
    },
    onError: (err) => {
      toast.error(
        err?.response?.data?.message ||
          "Failed to save order settings. Please try again.",
        {
          position: "top-right",
          duration: 3000,
        }
      );
    }
  });

  const saveOrderSettings = (formData) => {
    const payload = {
      order_settings_id: formData.order_settings_id || "",
      company_settings_id: formData.company_settings_id || "",
      return_period: Number(formData.returnPeriod) || 0,
      status: formData.enabled ? "ENABLED" : "DISABLED",
      settings_type: formData.settings_type,
      is_cod_allowed: !!formData.isCodAllowed,
      cod_value: Number(formData.codValue) || 0,
      minimum_cart_value: Number(formData.minimumCartValue) || 0,
    };
    setDataToServer.mutate(payload, { ...payload });
  };

  return {
    orderSettingsData: orderSettingsData,
    saving: setDataToServer.isLoading,
    saveOrderSettings,
    paramsObject,
    setGetListParams,
  };
};

export default useOrderSettings;
